import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useNoticesStore = defineStore('notices', () => {
  const notice = ref(null as string | null)
  const alert = ref(null as string | null)
  // const doubleCount = computed(() => count.value * 2)

  function clear() {
    notice.value = null
    alert.value = null
  }

  function setNotice(msg: string) {
    notice.value = msg
  }

  function setAlert(msg: string) {
    alert.value = msg
  }

  return { notice, alert, clear, setNotice, setAlert }
})
